type Distinctions = {
	fr: {
		title: string;
		reward: string;

	}

}[]


export const distinctions: Distinctions = [
	{
		"fr": {
			"title": "Festival de l'oiseau et de la Nature 2021",
			"reward": "Prix du public"
		}
	},
	{
		"fr": {
			"title": "concours Anticlichés 2021",
			"reward": "Premier prix catégorie meilleure photo"
		}
	},
	{
		"fr": {
			"title": "Concours ANUMA 2020",
			"reward": "Premier prix catégorie Golden Hour & Deuxième prix catégorie Invisible/Visible"
		}
	},
	{
		"fr": {
			"title": "Concours photo du Salon De l’Écologie 2018",
			"reward": "Premier prix et prix \"coup de cœur\""
		}
	}
];

export const exposition: Distinctions = [
	{
		"fr": {
			"title": "octobre-décembre 2022",
			"reward": "« Lumières d’Occitanie » au Bonobo café, Montpellier"
		}
	}
];

export const press: Distinctions = [
	{
		"fr": {
			"title": "Prière de ne pas déranger",
			"reward": "Reportage sur mon activité de photographe et écologue dans la Gazette de Montpellier n°1817 - du 13 au 19 avril 2023."
		}
	}
]
